import { render, staticRenderFns } from "./order_express_and_consignee.vue?vue&type=template&id=e978c4e0&"
import script from "./order_express_and_consignee.vue?vue&type=script&lang=js&"
export * from "./order_express_and_consignee.vue?vue&type=script&lang=js&"
import style0 from "./order_express_and_consignee.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports